{
  "name": "55-1/6-Pythagorean Comma MT (abbbb-g####)",
  "description": "55-tone scale in extended 1/6 Pythagorean Comma meantone. Each fifth in the range A♭♭♭♭-G♯♯♯♯ is narrowed from its JI ratio 2:3 by 1/6 of a Pythagorean Comma (524288:531441 = ca. 23.5c), so that six successive fifths produce a Pythagorean tritone (512:729). Standard 12-tone meantone usually ranges from E♭ to G♯, leaving a so-called \"wolf\" fifth. By extending the tuning to 55 notes, a circulating well-temperament is produced.",
  "scale": [
    "23.46001038",
    "46.92002077",
    "62.85498356",
    "86.31499394",
    "109.7750043",
    "133.2350147",
    "149.1699775",
    "172.6299879",
    "196.0899983",
    "219.5500087",
    "243.010019",
    "258.9449818",
    "282.4049922",
    "305.8650026",
    "329.325013",
    "345.2599758",
    "368.7199862",
    "392.1799965",
    "415.6400069",
    "439.1000173",
    "455.0349801",
    "478.4949905",
    "501.9550009",
    "525.4150113",
    "548.8750216",
    "564.8099844",
    "588.2699948",
    "611.7300052",
    "635.1900156",
    "651.1249784",
    "674.5849887",
    "698.0449991",
    "721.5050095",
    "744.9650199",
    "760.8999827",
    "784.3599931",
    "807.8200035",
    "831.2800138",
    "847.2149766",
    "870.674987",
    "894.1349974",
    "917.5950078",
    "941.0550182",
    "956.989981",
    "980.4499913",
    "1003.910002",
    "1027.370012",
    "1043.304975",
    "1066.764985",
    "1090.224996",
    "1113.685006",
    "1137.145016",
    "1153.079979",
    "1176.53999",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "43-MT-1_5-SC",
  "built_in_group": "Extended Meantone",
  "key_labels": "note_names",
  "note_names": [
    "c",
    "♭♭d",
    "♭♭♭♭e",
    "♯♯b",
    "♯c",
    "♭d",
    "♭♭♭e",
    "♯♯♯b",
    "♯♯c",
    "d",
    "♭♭e",
    "♭♭♭f",
    "♯♯♯c",
    "♯d",
    "♭e",
    "♭♭f",
    "♯♯♯♯c",
    "♯♯d",
    "e",
    "♭f",
    "♭♭♭g",
    "♯♯♯d",
    "♯e",
    "f",
    "♭♭g",
    "♭♭♭♭a",
    "♯♯e",
    "♯f",
    "♭g",
    "♭♭♭a",
    "♯♯♯e",
    "♯♯f",
    "g",
    "♭♭a",
    "♭♭♭♭b",
    "♯♯♯f",
    "♯g",
    "♭a",
    "♭♭♭b",
    "♯♯♯♯f",
    "♯♯g",
    "a",
    "♭♭b",
    "♭♭♭c",
    "♯♯♯g",
    "♯a",
    "♭b",
    "♭♭c",
    "♯♯♯♯g",
    "♯♯a",
    "b",
    "♭c",
    "♭♭♭d",
    "♯♯♯a",
    "♯b"
  ],
  "note_colors": [
    "#ffdbdb",
    "#ffe5e5",
    "#e4fbe6",
    "#fffae5",
    "#dee2da",
    "#d0d0d7",
    "#dce1d0",
    "#f8ffeb",
    "#fffae5",
    "#ffffff",
    "#ffe5e5",
    "#dce1d0",
    "#f8ffeb",
    "#dee2da",
    "#d0d0d7",
    "#ffe5e5",
    "#cee3e2",
    "#fffae5",
    "#ffffff",
    "#d0d0d7",
    "#dce1d0",
    "#f8ffeb",
    "#dee2da",
    "#ffffff",
    "#ffe5e5",
    "#e4fbe6",
    "#fffae5",
    "#dee2da",
    "#d0d0d7",
    "#dce1d0",
    "#f8ffeb",
    "#fffae5",
    "#ffffff",
    "#ffe5e5",
    "#e4fbe6",
    "#f8ffeb",
    "#dee2da",
    "#d0d0d7",
    "#dce1d0",
    "#cee3e2",
    "#fffae5",
    "#ffffff",
    "#ffe5e5",
    "#dce1d0",
    "#f8ffeb",
    "#dee2da",
    "#d0d0d7",
    "#ffe5e5",
    "#cee3e2",
    "#fffae5",
    "#ffffff",
    "#d0d0d7",
    "#dce1d0",
    "#f8ffeb",
    "#dee2da"
  ],
  "equivSteps": 55,
  "fundamental": 440,
  "reference_degree": 41,
  "center_degree": 0,
  "rSteps": 9,
  "drSteps": 5,
  "hexSize": 42,
  "rotation": -16.102113751
}
